"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectApophisCorpEffect = void 0;
var DeferredAction_1 = require("./DeferredAction");
var OrOptions_1 = require("../inputs/OrOptions");
var SelectOption_1 = require("../inputs/SelectOption");
var constants_1 = require("../constants");
var LogHelper_1 = require("../LogHelper");
var SelectApophisCorpEffect = (function () {
    function SelectApophisCorpEffect(player, title) {
        if (title === void 0) { title = 'Select Apophis Corporation Effect'; }
        this.player = player;
        this.title = title;
        this.priority = DeferredAction_1.Priority.DEFAULT;
    }
    SelectApophisCorpEffect.prototype.execute = function () {
        var _this = this;
        var tempCanBeRaised = this.player.game.getTemperature() < constants_1.MAX_TEMPERATURE;
        var venusCanBeRaised = this.player.game.gameOptions.venusNextExtension && this.player.game.getVenusScaleLevel() < constants_1.MAX_VENUS_SCALE;
        var paramsCanBeRaised = tempCanBeRaised || venusCanBeRaised;
        if (this.player.corporationCard === undefined || this.player.corporationCard.resourceCount === undefined)
            return undefined;
        var hasAsteroids = this.player.corporationCard.resourceCount > 0;
        var raiseParameter = new SelectOption_1.SelectOption('Remove 1 asteroid on this card to increase temperature or Venus 1 step', 'Remove asteroid', function () {
            if (_this.player.corporationCard === undefined || _this.player.corporationCard.resourceCount === undefined)
                return undefined;
            _this.player.corporationCard.resourceCount--;
            if (!tempCanBeRaised) {
                _this.player.game.increaseVenusScaleLevel(_this.player, 1);
                LogHelper_1.LogHelper.logVenusIncrease(_this.player, 1);
            }
            else if (!venusCanBeRaised) {
                _this.player.game.increaseTemperature(_this.player, 1);
                LogHelper_1.LogHelper.logTemperatureIncrease(_this.player, 1);
            }
            else {
                var raiseTempOption = new SelectOption_1.SelectOption('Increase temperature 1 step', 'Increase temperature', function () {
                    _this.player.game.increaseTemperature(_this.player, 1);
                    LogHelper_1.LogHelper.logTemperatureIncrease(_this.player, 1);
                    return undefined;
                });
                var raiseVenusOption = new SelectOption_1.SelectOption('Increase Venus 1 step', 'Increase Venus', function () {
                    _this.player.game.increaseVenusScaleLevel(_this.player, 1);
                    LogHelper_1.LogHelper.logVenusIncrease(_this.player, 1);
                    return undefined;
                });
                return new OrOptions_1.OrOptions(raiseTempOption, raiseVenusOption);
            }
            return undefined;
        });
        var addAsteroidToSelf = new SelectOption_1.SelectOption('Add 1 asteroid to this card', 'Add asteroid', function () {
            if (_this.player.corporationCard === undefined || _this.player.corporationCard.resourceCount === undefined)
                return undefined;
            _this.player.addResourceTo(_this.player.corporationCard, { log: true });
            return undefined;
        });
        if (hasAsteroids && paramsCanBeRaised) {
            return new OrOptions_1.OrOptions(raiseParameter, addAsteroidToSelf);
        }
        else {
            if (this.player.corporationCard === undefined || this.player.corporationCard.resourceCount === undefined)
                return undefined;
            this.player.addResourceTo(this.player.corporationCard, { log: true });
            return undefined;
        }
    };
    return SelectApophisCorpEffect;
}());
exports.SelectApophisCorpEffect = SelectApophisCorpEffect;
//# sourceMappingURL=SelectApophisCorpEffect.js.map